import { useDispatch } from 'react-redux';
import { getLimits } from '@/store/actions/limitsActions';
import { getUserWallet } from '@/store/wallet/actions';
import { getBonuses } from '@/store/bonuses/actions';

export function useUpdateUser(): {
  updateUser: () => void;
  updateUserWithTimeout: (timeout: number) => void;
} {
  const dispatch = useDispatch();

  const updateUser = () => {
    dispatch(getUserWallet());
    dispatch(getBonuses());
    dispatch(getLimits());
  };

  const updateUserWithTimeout = (timeout: number): void => {
    setTimeout(() => {
      updateUser();
    }, timeout);
  };

  return { updateUser, updateUserWithTimeout };
}
